import { Routes } from '@angular/router';
import { DescriptionComponent } from '@pages/description/description.component';
import { ErrorComponent } from '@pages/error/error.component';

import { MainLayoutComponent } from './layouts/main-layout.component';
import { SlimLayoutComponent } from './layouts/slim-layout.component';

export const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      { path: '', component: DescriptionComponent },
      {
        path: 'device',
        loadComponent: () =>
          import('./pages/device/device.component').then(({ DeviceComponent }) => DeviceComponent),
      },
      {
        path: 'contact',
        loadComponent: () =>
          import('./pages/contact/contact.component').then(
            ({ ContactComponent }) => ContactComponent,
          ),
      },
    ],
  },
  {
    path: '',
    component: SlimLayoutComponent,
    children: [
      {
        path: 'confirmation',
        loadComponent: () =>
          import('./pages/confirmation/confirmation.component').then(
            ({ ConfirmationComponent }) => ConfirmationComponent,
          ),
      },
      { path: '**', component: ErrorComponent },
    ],
  },
];
